module.exports = __webpack_public_path__ + "static/media/ic-isometric-press.69fdfedb.png";